import { render, staticRenderFns } from "./SinMenu.vue?vue&type=template&id=57c10c56&scoped=true&"
import script from "./SinMenu.vue?vue&type=script&lang=ts&"
export * from "./SinMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SinMenu.vue?vue&type=style&index=0&id=57c10c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c10c56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
